import { Component, OnInit, ViewChild, ElementRef, Inject, TemplateRef } from '@angular/core';
import {
  INCIDENTTYPEDATA, INCIDENTDATAUPLOADSQL, INCIDENTTYPE, INCIDENTUPLOAD, VIEWDASHBOARD, COLUMNNAMESSQL,
  FILE_VALIDATION_MESSAGE, SELECT_INCIDENT_VALIDATION_MESSAGE, API_ERROR_MESSAGE, FILENAME_VALIDATION_MESSAGE,
  FILE_UPLOAD_SUCCESS_MESSAGE, NO_RECORDS, ERRORDETAILSSQL, EXCHANGERATEUPLOAD, FILE_UPLOAD_STATUS
} from '../common/constants/labels';
import { IncidentUploadSqlService } from './incident-upload-sql.service';
import { map, takeUntil } from 'rxjs/operators';
import { HttpEvent, HttpEventType, HttpResponse } from '@angular/common/http';
import { Subject } from 'rxjs';
import { UploadedIncidentFileDetails } from '../common/models/incident-upload';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Role } from '../common/models/role';
import { Router } from '@angular/router';
import { FormControl, FormGroup } from '@angular/forms';
import { DashboardSqlService } from '../dashboard-sql/dashboard-sql.service';
import { ClusterSiteBigCategoryData } from '../common/models/ClusterFactory';
import { CurrencyList } from '../common/models/incident-dashboard-filterparameterdata';
import { AuthenticationService } from '../common/services/authentication.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

export interface DialogData {
  name: '';
}

export interface ErrorDetails {
  name: any;
}

@Component({
  selector: 'app-incident-upload-sql',
  templateUrl: './incident-upload-SQL.component.html',
  styleUrls: ['./incident-upload.component.scss']
})

// Component loads the incident data upload screen
export class IncidentUploadSQLComponent implements OnInit {
  title = 'Data Upload';
  incidentType = INCIDENTTYPEDATA;
  defaultIncidentType = INCIDENTTYPE;
  incidentDataUpload = INCIDENTDATAUPLOADSQL;
  exchangeRateUpload = EXCHANGERATEUPLOAD;
  incidentUpload = INCIDENTUPLOAD;
  viewDashboard = VIEWDASHBOARD;
  showIncidentType = true;
  displayedColumns: any;
  dataSource: Array<UploadedIncidentFileDetails> = [];
  fileToUpload: File = null;
  currencyfileToUpload: File = null;
  fileName: string = null;
  incidentTypeValue: string;
  showSuccess = false;
  showValidation = false;
  showFileValidation = false;
  apiError = false;
  progressValue = 0;
  showProgress = false;
  validateSG = '';
  formattedString;
  @ViewChild('files', { static: false }) myInputVariable: ElementRef;
  @ViewChild('currencyfiles', { static: false }) myCurrencyInputVariable: ElementRef;
  private rxUnsubscribe: Subject<void> = new Subject<void>();
  private currencyrxUnsubscribe: Subject<void> = new Subject<void>();
  fileValidationMsg = FILE_VALIDATION_MESSAGE;
  selectDropdownMsg = SELECT_INCIDENT_VALIDATION_MESSAGE;
  apiErrorMsg = API_ERROR_MESSAGE;
  noRecords = NO_RECORDS;
  noRecordsShow = false;
  loading = true;
  role;
  uploadinserted = '';
  uploadrejected = '';
  uploadduplicated = '';
  uploadupdated = '';
  recordInserted = '';
  recordRejected = '';
  recordDuplicated = '';
  recordUpdated = '';
  errorDetailsResponse: any;
  incidentUploadSqlForm = new FormGroup({
    uploadclusters: new FormControl(),
    uploadsite: new FormControl(),
    bigcategories: new FormControl(),
    currency: new FormControl()
  });
  cluster: string[] = [];
  sites: string[] = [];
  bigcategoryU: string[] = [];
  currencies: string[] = [];

  factory: string[] = [];
  category: string[] = ['All'];
  clustersitebigcategoryArray: Array<ClusterSiteBigCategoryData> = [];
  disableUpload = true;
  clusterdefault = '';
  sitedefault = '';
  bigcategorydefault = '';
  disableCluster = false;
  disableSite = false;
  currencyList: Array<CurrencyList> = [];
  deleteincidentdata = false;
  freezeUpload;
  labelDisplay: string;
  fileUploadStatus = FILE_UPLOAD_STATUS;
  fileUploadStatusCSS = 'alert alert-danger failMsg';
  @ViewChild('paginator', {static: false}) paginator!: MatPaginator;
  fileDetailsDataSource!: MatTableDataSource<any>;
  username = '';
  public useremailaddress = '';

  constructor(private incidentservice: IncidentUploadSqlService, public dialog: MatDialog, private router: Router, private dashboardsqlservice: DashboardSqlService, private authenticateService: AuthenticationService) {
  }
  ngOnInit() {
    this.displayedColumns = COLUMNNAMESSQL;
    this.getCurrencyList();
    this.getClusterSiteBigCategoryData();
    this.role = localStorage.getItem('role');
    this.username = localStorage.getItem('UserName');
    this.useremailaddress = localStorage.getItem('UserEmailAddress').toLowerCase();
    if (this.role === Role.globalAdmin) {
      this.deleteincidentdata = true;
    } else {
      this.deleteincidentdata = false;
    }
    this.getUploadstatus();
    this.getRoleAccess();
    // if (this.incidentUploadSqlForm.get('uploadsite').value !== null && this.incidentUploadSqlForm.get('uploadclusters').value !== null
    //   && this.incidentUploadSqlForm.get('bigcategories').value !== null && this.incidentUploadSqlForm.get('currency').value !== null &&
    //   this.incidentUploadSqlForm.get('currency').value !== undefined && this.incidentUploadSqlForm.get('currency').value !== 'default'
    //    && this.role === Role.globalAdmin) {
    //   this.disableUpload = false;
    // } else {
    //   this.disableUpload = true;
    // }
  }
  getUploadstatus() {
    this.loading = true;
    this.incidentservice.getUploadStatus().subscribe((resp: any) => {
      this.loading = false;
      if (resp) {
        if (resp.freezeStatus) {
          this.freezeUpload = true;
          this.labelDisplay = 'Unfreeze Upload';
        } else {
          this.freezeUpload = false;
          this.labelDisplay = 'Freeze Upload';
        }
      } else {
        this.freezeUpload = false;
        this.labelDisplay = 'Freeze Upload';
      }
    });
  }
  getCurrencyList() {
    this.incidentservice.getCurrency().subscribe((response) => {
      if (response.length > 0) {
        const currencyArray = [];
        response.forEach((e) => {
          let object = {};
          object = {
            currencyunit: e.currencyunit,
            site: e.site,
            currencycode: e.currencycode
          };
          currencyArray.push(object);
        });
        this.currencyList = currencyArray;
      }
    });
  }
  disableAllUpload() {
    let status;
    status = this.freezeUpload ? false : true;
    this.loading = true;
    this.showFileValidation = false;
    this.incidentservice.saveFreezeStatus(status).subscribe((resp) => {
      this.loading = false;
      if (resp.message === 'Success') {
        this.freezeUpload = true;
        this.labelDisplay = 'Unfreeze Upload';
      } else {
        this.freezeUpload = false;
        this.labelDisplay = 'Freeze Upload';
      }
      this.getUploadstatus();
    },
      (error) => {
        console.log(error);
      });
  }
  // method to display uploaded file details in table
  getIncidentFileDetails() {
    let cluster = '';
    let site = '';
    if (this.role === Role.qualityChampion) {
      cluster = this.clusterdefault;
      site = null;
    } else if (this.role === Role.globalAdmin) {
      cluster = null;
      site = null;
    } else {
      cluster = null;
      site = this.sitedefault;
    }
    this.incidentservice.getIncidentFiles(cluster, site, this.role).subscribe((response) => {
      if (response.length === 0) {
        this.noRecordsShow = true;
        this.loading = false;
      } else {
        this.noRecordsShow = false;
        const UpdatedResponse = [];
        response.forEach((e) => {
          let object = {};
          object = {
            fileID: e.fileID,
            fileName: e.fileName,
            uploadedDate: e.uploadedDate,
            uploadedBy: e.uploadedBy,
            uploadedStatus: e.uploadedStatus,
            localCurrency: e.localCurrency
          };
          UpdatedResponse.push(object);
        });
        UpdatedResponse.sort((a, b) => {
          return <any> (b.uploadedDate) - <any> (a.uploadedDate);
        });

        this.dataSource = UpdatedResponse;
        this.fileDetailsDataSource = new MatTableDataSource(UpdatedResponse);
        this.fileDetailsDataSource.paginator = this.paginator;
        this.loading = false;
      }
    }, (error) => {
      this.fileValidationMsg = 'Failed to get the file details. Please try after sometime.';
      this.showFileValidation = true;
      this.loading = false;
    });
  }

  // method to display error details
  /* istanbul ignore next */
  getErrorDetails(fileId: string) {
    this.incidentservice.getErrorDetails(fileId).subscribe((response) => {
      const UpdatedErrorResponse = [];
      response.forEach((e) => {
        let object = {};
        object = {
          Row: e.excelRow,
          Reason: e.errorMessage,
          Status: e.rowStatus
        };
        UpdatedErrorResponse.push(object);
      });
      this.errorDetailsResponse = UpdatedErrorResponse;
      this.loading = false;
      this.openUploadErrorDetails();
    }, (error) => {
      this.fileValidationMsg = 'Failed to get the uploaded file, error details. Please try after sometime.';
      this.showFileValidation = true;
      this.loading = false;
    });
  }

  loadSite() {
    this.disableUpload = true;
    this.bigcategoryU = [];
    this.currencies = [];
    this.sites = [];
    const tempArray: string[] = [];
    this.incidentUploadSqlForm.get('uploadsite').setValue(null);
    let clusterSelected = '';
    this.showSuccess = false;
    this.showFileValidation = false;
    if (this.incidentUploadSqlForm.get('uploadclusters').value.length > 0) {
      clusterSelected = this.incidentUploadSqlForm.get('uploadclusters').value;
      this.clustersitebigcategoryArray.forEach(element => {
        if (clusterSelected === element.subregion) {
          tempArray.push(element.site);
        }
      });
      this.sites = tempArray.map(item => item).filter((value, index, self) => self.indexOf(value) === index).sort();
    }
    this.incidentUploadSqlForm.get('currency').reset();
  }

  loadBigCategory() {
    this.bigcategoryU = [];
    this.currencies = [];
    this.incidentUploadSqlForm.get('bigcategories').setValue(null);
    let siteSelected = '';
    const tempArray: string[] = [];
    this.showSuccess = false;
    this.showFileValidation = false;
    if (this.incidentUploadSqlForm.get('uploadsite').value.length > 0) {
      siteSelected = this.incidentUploadSqlForm.get('uploadsite').value;
      this.clustersitebigcategoryArray.forEach(element => {
        if (siteSelected === element.site) {
          tempArray.push(element.businessgroup);
        }
      });
      this.bigcategoryU = tempArray.map(item => item).filter((value, index, self) => self.indexOf(value) === index).sort();
    }
    if (this.incidentUploadSqlForm.get('bigcategories').value === null) {
      this.disableUpload = true;
    } else {
      this.disableUpload = false;
    }
    this.incidentUploadSqlForm.get('currency').reset();
  }

  getClusterSiteBigCategoryData() {

    this.dashboardsqlservice.getClusterFactoryData().subscribe((response) => {
      if (response.length === 0) {
        this.fileValidationMsg = 'Failed to get the cluster, site and Bigcategory. Please try after sometime.';
        this.showFileValidation = true;
        this.loading = false;
      } else {
        // this.noRecordsShow = false;
        // const UpdatedResponse = [];
        response.forEach((e) => {
          let object: ClusterSiteBigCategoryData;
          object = {
            subregion: e.subregion,
            site: e.site,
            businessgroup: e.businessgroup,
            factoryname: e.factoryname
          };
          this.clustersitebigcategoryArray.push(object);
        });
        this.cluster = this.clustersitebigcategoryArray.map(item => item.subregion).filter((value, index, self) => self.indexOf(value) === index).sort();
        this.selectClusterSiteDropdownwithdefault();
      }
    }, (error) => {
      this.fileValidationMsg = 'Failed to get the cluster, site and Bigcategory. Please try after sometime.';
      this.showFileValidation = true;
      this.loading = false;
    });
  }



  // method is invoked to rotate the dropdown icon
  incidentTypeDefaultValue() {
    this.apiError = false;
    this.showValidation = false;
    this.showFileValidation = false;
    this.showIncidentType = !this.showIncidentType;
  }
  // when user will click outside anywhere in the page dropdown will close
  focusOutIncidentType() {
    this.showIncidentType = true;
  }

  findSiteNameInFactoryName(factory: string, site: string) {
    if (factory.toLowerCase().includes(site.toLowerCase())) {
      return true;
    } else if (site.indexOf('-') > 0) {
      const siteArray = site.split('-');
      siteArray.forEach(s => {
        if (factory.toLowerCase().includes(s.toLowerCase())) {
          return true;
        }
      });
    } else if (site.indexOf(' ') > 0) {
      const siteArray = site.split(' ');
      siteArray.forEach(s => {
        if (factory.toLowerCase().includes(s.toLowerCase())) {
          return true;
        }
      });
    }
  }

  selectClusterSiteDropdownwithdefault() {
    this.loading = true;
    let factory = '';
    factory = localStorage.getItem('factory');
    const tempArray: string[] = [];
    for (let i = 0; i < this.clustersitebigcategoryArray.length; i++) {
      const factoryname = this.clustersitebigcategoryArray[i].factoryname;
      const site = this.clustersitebigcategoryArray[i].site;
      const bigcategory = this.clustersitebigcategoryArray[i].businessgroup;
      const clustername = this.clustersitebigcategoryArray[i].subregion;
      if (factoryname === factory || this.authenticateService.findSiteNameInFactoryName(factory, site)) {
        this.clusterdefault = clustername;
        this.clustersitebigcategoryArray.forEach(element => {
          if (clustername === element.subregion) {
            tempArray.push(element.site);
          }
        });
        this.sites = tempArray.map(item => item).filter((value, index, self) => self.indexOf(value) === index).sort();
        this.sitedefault = site;
        this.bigcategorydefault = bigcategory;
        const currencyArr = this.currencyList.filter((c) => site.toLowerCase() === c.site.toLowerCase() || c.site.startsWith(site));
        const currencyArrayDistinct = [];
        currencyArr.forEach(x => {
          currencyArrayDistinct.push(x.currencyunit);
        });
        this.currencies = currencyArrayDistinct.map(item => item).filter((value, index, self) => self.indexOf(value) === index);
        const val = this.currencies.filter(X => X === 'Euro');
        if (val.length === 0) {
          this.currencies.unshift('Euro');
        }
        const bigArray: string[] = [];
        this.clustersitebigcategoryArray.forEach(element => {
          if (site === element.site) {
            bigArray.push(element.businessgroup);
          }
        });
        this.bigcategoryU = bigArray.map(item => item).filter((value, index, self) => self.indexOf(value) === index).sort();
        if (this.role === Role.qualityChampion) {
          this.disableSite = false;
          this.disableCluster = true;
        } else if (this.role === Role.globalAdmin) {
          this.disableSite = false;
          this.disableCluster = false;
        } else {
          this.disableSite = true;
          this.disableCluster = true;
        }
        this.getIncidentFileDetails();
        break;
      }
    }
    /* this.clustersitebigcategoryArray.forEach(clusterfilter => {
      if (clusterfilter.factoryname === factory || this.authenticateService.findSiteNameInFactoryName(factory, clusterfilter.site)) {
        console.log("factoryname: " +clusterfilter.factoryname);
        console.log("clustername: " +clusterfilter.clustername + ", site: " +clusterfilter.site);
        this.clusterdefault = clusterfilter.clustername;

        this.clustersitebigcategoryArray.forEach(element => {
          if (clusterfilter.clustername === element.clustername) {
            console.log("clustername: " +clusterfilter.clustername + ", site: " +clusterfilter.site);
            tempArray.push(element.site);
          }
        });
        this.sites = tempArray.map(item => item).filter((value, index, self) => self.indexOf(value) === index).sort();
        this.sitedefault = clusterfilter.site;
        this.bigcategorydefault = clusterfilter.bigcategory;
        const currencyArr = this.currencyList.filter((c) => clusterfilter.site.toLowerCase() === c.site.toLowerCase() || c.site.startsWith(clusterfilter.site));
        const currencyArrayDistinct = [];
        currencyArr.forEach(x => {
          currencyArrayDistinct.push(x.currencyunit);
        });
        this.currencies = currencyArrayDistinct.map(item => item).filter((value, index, self) => self.indexOf(value) === index);
        const val = this.currencies.filter(X => X === 'Euro');
        if (val.length === 0) {
          this.currencies.push('Euro');
        }
        const bigArray: string[] = [];
        this.clustersitebigcategoryArray.forEach(element => {
          if (clusterfilter.site === element.site) {
            bigArray.push(element.bigcategory);
          }
        });
        this.bigcategoryU = bigArray.map(item => item).filter((value, index, self) => self.indexOf(value) === index).sort();
        if (this.role === Role.qualityChampion) {
          this.disableSite = false;
          this.disableCluster = true;
        } else if (this.role === Role.globalAdmin) {
          this.disableSite = false;
          this.disableCluster = false;
        } else {
          this.disableSite = true;
          this.disableCluster = true;
        }
        this.getIncidentFileDetails();
        // this.loading = false;
      }
    }); */
    if (this.clusterdefault === '') {
      const clusterdata = [];
      this.loading = true;
      this.role = localStorage.getItem('role');
      const clusterBasedOnRole = localStorage.getItem('clusterBasedOnRole');
      let clusterBasedOnRoleparsed = [];
      if (clusterBasedOnRole !== null && clusterBasedOnRole !== undefined) {
        clusterBasedOnRoleparsed = JSON.parse(clusterBasedOnRole);
        this.clusterdefault = clusterBasedOnRoleparsed[0];
        this.clustersitebigcategoryArray.forEach(element => {
          if (clusterBasedOnRoleparsed[0] === element.subregion) {
            tempArray.push(element.site);
          }
        });
        this.sites = tempArray.map(item => item).filter((value, index, self) => self.indexOf(value) === index).sort();
        // Need to remove this below hard coded site assigment
        if (this.useremailaddress === 'huimin.zhao@unilever.com') {
          this.sitedefault = 'HeFei - PCL';
         } else if (this.useremailaddress === 'shuyi.chen@unilever.com') {
          this.sitedefault = 'HeFei - Skin Care';
         } else if (this.useremailaddress === 'yajuan.he@unilever.com') {
          this.sitedefault = 'Hefei - Laundry';
         } else if (this.useremailaddress === 'bin-ygf.zhang@unilever.com') {
          this.sitedefault = 'HeFei - Home & Hygiene';
         } else if (this.useremailaddress === 'chun-juan.yuan@unilever.com') {
          this.sitedefault = 'HeFei - Home & Hygiene';
         } else if (this.useremailaddress === 'ju.liu2@unilever.com') {
          this.sitedefault = 'HeFei - Oral Care';
         } else if (this.useremailaddress === 'srikanth.bugga@unilever.com') {
          this.sitedefault = 'HeFei - Oral Care';
         } else {
         this.sitedefault = this.sites[0];
         }
        const currencyArr = this.currencyList.filter((c) => this.sites[0] === c.site || c.site.startsWith(this.sites[0]));
        const currencyArrayDistinct = [];
        currencyArr.forEach(x => {
          currencyArrayDistinct.push(x.currencyunit);
        });
        this.currencies = currencyArrayDistinct.map(item => item).filter((value, index, self) => self.indexOf(value) === index);
        const val = this.currencies.filter(X => X === 'Euro');
        if (val.length === 0) {
          this.currencies.unshift('Euro');
        }
        const bigArray: string[] = [];
        this.clustersitebigcategoryArray.forEach(element => {
          if (this.sites[0] === element.site) {
            bigArray.push(element.businessgroup);
          }
        });
        this.bigcategoryU = bigArray.map(item => item).filter((value, index, self) => self.indexOf(value) === index).sort();
        if (this.role === Role.qualityChampion) {
          this.disableSite = false;
          this.disableCluster = true;
        } else if (this.role === Role.globalAdmin) {
          this.disableSite = false;
          this.disableCluster = false;
        } else {
          this.disableSite = true;
          this.disableCluster = true;
        }
        this.getIncidentFileDetails();
        // this.loading = false;
      } else {
        this.dashboardsqlservice.getClusterFromDFOS(this.role).subscribe((response) => {
          if (response !== null) {
            response.forEach(element => {
              clusterdata.push(element.name);
            });
            localStorage.setItem('clusterBasedOnRole', JSON.stringify(clusterdata));
            this.clusterdefault = clusterdata[0];
            this.clustersitebigcategoryArray.forEach(element => {
              if (clusterdata[0] === element.subregion) {
                tempArray.push(element.site);
              }
            });

            this.sites = tempArray.map(item => item).filter((value, index, self) => self.indexOf(value) === index).sort();
            // Need to remove this below hard coded site assigment
            if (this.useremailaddress === 'huimin.zhao@unilever.com') {
              this.sitedefault = 'HeFei - PCL';
             } else if (this.useremailaddress === 'shuyi.chen@unilever.com') {
              this.sitedefault = 'HeFei - Skin Care';
             } else if (this.useremailaddress === 'yajuan.he@unilever.com') {
              this.sitedefault = 'Hefei - Laundry';
             } else if (this.useremailaddress === 'bin-ygf.zhang@unilever.com') {
              this.sitedefault = 'HeFei - Home & Hygiene';
             } else if (this.useremailaddress === 'chun-juan.yuan@unilever.com') {
              this.sitedefault = 'HeFei - Home & Hygiene';
             } else if (this.useremailaddress === 'ju.liu2@unilever.com') {
              this.sitedefault = 'HeFei - Oral Care';
             } else if (this.useremailaddress === 'srikanth.bugga@unilever.com') {
              this.sitedefault = 'HeFei - Oral Care';
             } else {
              this.sitedefault = this.sites[0];
            }
            const currencyArr = this.currencyList.filter((c) => this.sites[0] === c.site || c.site.startsWith(this.sites[0]));
            const currencyArrayDistinct = [];
            currencyArr.forEach(x => {
              currencyArrayDistinct.push(x.currencyunit);
            });
            this.currencies = currencyArrayDistinct.map(item => item).filter((value, index, self) => self.indexOf(value) === index);
            const val = this.currencies.filter(X => X === 'Euro');
            if (val.length === 0) {
              this.currencies.unshift('Euro');
            }
            const bigArray: string[] = [];
            this.clustersitebigcategoryArray.forEach(element => {
              if (this.sites[0] === element.site) {
                bigArray.push(element.businessgroup);
              }
            });
            this.bigcategoryU = bigArray.map(item => item).filter((value, index, self) => self.indexOf(value) === index).sort();

            if (this.role === Role.qualityChampion) {
              this.disableSite = false;
              this.disableCluster = true;
            } else if (this.role === Role.globalAdmin) {
              this.disableSite = false;
              this.disableCluster = false;
            } else {
              this.disableSite = true;
              this.disableCluster = true;
            }
          }
          this.getIncidentFileDetails();
          // this.loading = false;
        });
      }
    }
  }

  getRoleAccess() {
    if (this.role === Role.globalAdmin || this.role === Role.qualityFactoryUser || this.role === Role.qualityChampion) {
      if (this.incidentUploadSqlForm.get('uploadsite').value !== null && this.incidentUploadSqlForm.get('uploadclusters').value !== null
      && this.incidentUploadSqlForm.get('bigcategories').value !== null && this.incidentUploadSqlForm.get('currency').value !== null &&
      this.incidentUploadSqlForm.get('currency').value !== undefined && this.incidentUploadSqlForm.get('currency').value !== 'default') {
      this.disableUpload = false;
      } else {
        this.disableUpload = true;
      }
    } else if (this.role === Role.qualityGlobalRead) {
      this.disableUpload = true;
    }
  }

  ClearCurrencyOnBigCategorySelect() {
    const siteSelected = this.incidentUploadSqlForm.get('uploadsite').value;
    this.getRoleAccess();
    // if (this.incidentUploadSqlForm.get('uploadsite').value !== null && this.incidentUploadSqlForm.get('uploadclusters').value !== null
    //   && this.incidentUploadSqlForm.get('bigcategories').value !== null && this.incidentUploadSqlForm.get('currency').value !== null &&
    //   this.incidentUploadSqlForm.get('currency').value !== undefined && this.incidentUploadSqlForm.get('currency').value !== 'default'
    //    && this.role === Role.globalAdmin) {
    //   this.disableUpload = false;
    // } else {
    //   this.disableUpload = true;
    // }

    const currencyArr = this.currencyList.filter((c) => siteSelected.toLowerCase() === c.site.toLowerCase() || c.site.startsWith(siteSelected));
    const currencyArrayDistinct = [];
    this.showSuccess = false;
    this.showFileValidation = false;
    currencyArr.forEach(x => {
      currencyArrayDistinct.push(x.currencyunit);
    });
    this.currencies = currencyArrayDistinct.map(item => item).filter((value, index, self) => self.indexOf(value) === index);
    const val = this.currencies.filter(X => X === 'Euro');
    if (val.length === 0) {
      this.currencies.unshift('Euro');
    }
   // this.incidentUploadSqlForm.controls.currency.setValue("default")
  }


  EnableFileUpload() {
    this.showSuccess = false;
    this.showFileValidation = false;
    this.getRoleAccess();
    // if (this.incidentUploadSqlForm.get('uploadsite').value !== null && this.incidentUploadSqlForm.get('uploadclusters').value !== null
    //   && this.incidentUploadSqlForm.get('bigcategories').value !== null && this.incidentUploadSqlForm.get('currency').value !== null
    //   && this.incidentUploadSqlForm.get('currency').value !== undefined && this.incidentUploadSqlForm.get('currency').value !== 'default'
    //   && this.role === Role.globalAdmin) {
    //   this.disableUpload = false;
    // } else {
    //   this.disableUpload = true;
    // }
  }

  filenameValidation(fileName: string) {
    const filenameSplit = fileName.replace('.xlsx', '').replace('.xlsm', '').replace('.xlsb', '').replace('.xls', '').replace('.csv', '');
    const filenameCheck = filenameSplit.split('_');
    const currentYear = new Date();
    if (filenameCheck.length === 4  && !isNaN(Number(filenameCheck[0]))
      && (Number(filenameCheck[0]) === currentYear.getFullYear() || ((Number(filenameCheck[0]) + 1) === currentYear.getFullYear()))
      && this.checkClusterCombinations(filenameCheck[1].trim().toLowerCase())
      && filenameCheck[2].trim().toLowerCase() === this.incidentUploadSqlForm.get('uploadsite').value.trim().toLowerCase()
      && this.checkBigCategoryCombinations(filenameCheck[3].trim().toLowerCase())) {
      return true;
    } else {
      return false;
    }
  }

  checkBigCategoryCombinations(bigCategory: string) {
    const selectedBigCategory = this.incidentUploadSqlForm.get('bigcategories').value.trim().toLowerCase();
    const refreshmentArray = ['Ice Cream', 'IC'];
    const personalCareArray = ['PC', 'Personal Care', 'PersonalCare', 'Personal_Care'];
    const foodsArray = ['Refreshments', 'Foods' , 'Food' , 'Nutrition'];
    const homeCareArray = ['HC', 'Home Care', 'HomeCare', 'Home_Care'];
    const BwArray = ['Beauty' , 'Beauty & Wellbeing' , 'Wellbeing'];
    let returnValue = false;

    switch (selectedBigCategory) {
      case 'ice cream':
        refreshmentArray.forEach(x => {
          if (x.toLowerCase() === bigCategory) {
            returnValue = true;
          }
        });
        break;
      case 'personal care':
        personalCareArray.forEach(x => {
          if (x.toLowerCase() === bigCategory) {
            returnValue = true;
          }
        });
        break;
      case 'nutrition':
        foodsArray.forEach(x => {
          if (x.toLowerCase() === bigCategory) {
            returnValue = true;
          }
        });
        break;
      case 'home care':
        homeCareArray.forEach(x => {
          if (x.toLowerCase() === bigCategory) {
            returnValue = true;
          }
        });
        break;
      case 'beauty & wellbeing':
        BwArray.forEach(x => {
          if (x.toLowerCase() === bigCategory) {
            returnValue = true;
          }
        });
        break;
    }
    return returnValue;
  }

  checkClusterCombinations(cluster: string) {
    const selectedCluster = this.incidentUploadSqlForm.get('uploadclusters').value.trim().toLowerCase();
    const anzArray = ['ANZ', 'Australia', '1UL ANZ', 'New Zealand', 'Australia & New Zealand'];
    const africaArray = ['AF', 'Africa', '1UL Africa'];
    const europeArray = ['EU', 'Europe'];
    const latinAmericaArray = ['LATAM', 'L_America', 'L America', 'Latin America', '1UL LATAM'];
    const russiaArray = ['1UL Russia', 'Russia'];
    const israelArray = ['1UL Israel', 'Israel'];
    const IndonesiaArray = ['Indonesia', 'Ind', 'SEA'];
    const northAmericaArray = ['NA', 'NorthAm', 'NorthAmerica', 'North_America', 'North America'];
    const northAsiaArray = ['NorthAsia', 'North Asia', 'North_Asia'];
    const seaaArray = ['SEAsia', 'SE', 'SEAA', 'SEA Excluding Indonesia'];
    const southAsiaArray = ['SA', 'South_Asia', 'SouthAsia', 'South Asia'];
    const MEAArray = ['Middle East', 'Ukraine', 'Turkey', 'MEA', 'Middle East, Turkey & Ukraine'];

    let returnValue = false;

    switch (selectedCluster) {
      case '1ul africa':
        africaArray.forEach(x => {
          if (x.toLowerCase() === cluster) {
            returnValue = true;
          }
        });
        break;
      case 'europe':
        europeArray.forEach(x => {
          if (x.toLowerCase() === cluster) {
            returnValue = true;
          }
        });
        break;
      case 'latin america':
        latinAmericaArray.forEach(x => {
          if (x.toLowerCase() === cluster) {
            returnValue = true;
          }
        });
        break;
      case '1ul latam':
        latinAmericaArray.forEach(x => {
          if (x.toLowerCase() === cluster) {
            returnValue = true;
          }
        });
        break;
      case '1ul anz':
        anzArray.forEach(x => {
          if (x.toLowerCase() === cluster) {
            returnValue = true;
          }
        });
        break;
      case '1ul russia':
        russiaArray.forEach(x => {
          if (x.toLowerCase() === cluster) {
            returnValue = true;
          }
        });
        break;
      case '1ul israel':
        israelArray.forEach(x => {
          if (x.toLowerCase() === cluster) {
            returnValue = true;
            }
        });
        break;
      case 'indonesia':
        IndonesiaArray.forEach(x => {
          if (x.toLowerCase() === cluster) {
            returnValue = true;
            }
        });
        break;
      case 'north america':
        northAmericaArray.forEach(x => {
          if (x.toLowerCase() === cluster) {
            returnValue = true;
          }
        });
        break;
      case 'north asia':
        northAsiaArray.forEach(x => {
          if (x.toLowerCase() === cluster) {
            returnValue = true;
          }
        });
        break;
      case 'sea excluding indonesia':
        seaaArray.forEach(x => {
          if (x.toLowerCase() === cluster) {
            returnValue = true;
          }
        });
        break;
      case 'middle east, turkey and ukraine':
        MEAArray.forEach(x => {
          if (x.toLowerCase() === cluster) {
            returnValue = true;
          }
        });
        break;
      case 'south asia':
        southAsiaArray.forEach(x => {
          if (x.toLowerCase() === cluster) {
            returnValue = true;
          }
        });
        break;
    }
    return returnValue;
  }

  confirmation() {
    if (window.confirm('Are sure you want to upload currency exchange rate?')) {
      return true;
    }
    return false;
  }

  // method for uploading file
  uploadCurrencyExchangeRate(currencyfiles: File) {
    this.validateSG = '';
    this.apiError = false;
    this.showValidation = false;
    this.showFileValidation = false;
    this.currencyfileToUpload = currencyfiles[0];
    const currencyfileName = currencyfiles[0].name;
    if ((!currencyfileName.endsWith('.xlsx')) && (!currencyfileName.endsWith('.xls')) && (!currencyfileName.endsWith('.xlsm'))
      && (!currencyfileName.endsWith('.xlsb')) && (!currencyfileName.endsWith('.csv'))) {
      this.fileValidationMsg = FILE_VALIDATION_MESSAGE;
      this.showFileValidation = true;
    } else {
      this.incidentservice.postFile(this.currencyfileToUpload, 'CURRENCYUPLOAD', 'CURRENCYUPLOAD', 'CURRENCYUPLOAD', 'CURRENCYUPLOAD').pipe(takeUntil(this.currencyrxUnsubscribe))
        .subscribe((event: HttpEvent<any>) => {
          if (event.type === 0) {
            this.progressValue = 25;
            this.showProgress = true;
          }
          if (event.type === 1) {
            this.progressValue = 50;
            this.showProgress = true;
          }
          if (event.type === 2) {
            this.progressValue = 75;
            this.showProgress = true;
          }
          if (event.type === 3) {
            this.progressValue = 100;
            setTimeout(() => {
              this.getCurrencyList();
              this.showProgress = false;
            }, 1000);
          }
          if (event.type === 4) {
            if (event instanceof HttpResponse) {
              this.fileValidationMsg = event.body.errorMessage;
              if (this.fileValidationMsg !== '' && this.fileValidationMsg !== null && this.fileValidationMsg !== undefined) {
                this.showFileValidation = true;
                if (this.fileValidationMsg === this.fileUploadStatus[0]) {
                  this.fileUploadStatusCSS = 'alert alert-success failMsg';
                }
                if (this.fileValidationMsg === this.fileUploadStatus[1]) {
                  this.fileUploadStatusCSS = 'alert alert-warning failMsg';
                }
                if (this.fileValidationMsg === this.fileUploadStatus[2]) {
                  this.fileUploadStatusCSS = 'alert alert-danger failMsg';
                }
              }
              this.recordInserted = event.body.totalRowsInserted;
              if (this.recordInserted != null) {
                this.uploadinserted = 'Number of records uploaded : ' + this.recordInserted;
                this.uploadrejected = '';
                this.uploadduplicated = '';
                this.showSuccess = true;
              }
              setTimeout(() => {
                this.showSuccess = false;
              }, 5000);
            }
          }
        }, (error) => {
          this.showProgress = false;
          this.showSuccess = false;
          this.validateSG = error.error.message;
          this.formattedString = this.validateSG.split('\n');
          this.openDialogError();
        });
    }
    this.myCurrencyInputVariable.nativeElement.value = '';
  }

  openInput() {
    document.getElementById('fileInput').click();
  }

  // method for uploading file
  uploadIncidentFile(files: File) {
    this.validateSG = '';
    this.apiError = false;
    this.showValidation = false;
    this.showFileValidation = false;
    this.fileToUpload = files[0];
    this.fileName = files[0].name;
    this.role = localStorage.getItem('role');
    if (this.freezeUpload) {
      this.fileValidationMsg = 'File upload not allowed. Please unfreeze upload or contact administrator.';
      this.showFileValidation = true;
    } else if ((!this.fileName.endsWith('.xlsx')) && (!this.fileName.endsWith('.xls')) && (!this.fileName.endsWith('.xlsm'))
      && (!this.fileName.endsWith('.xlsb')) && (!this.fileName.endsWith('.csv'))) {
      this.fileValidationMsg = FILE_VALIDATION_MESSAGE;
      this.showFileValidation = true;
    } else if ((this.role === Role.globalAdmin || this.role === Role.qualityChampion) && !this.filenameValidation(this.fileName)) {
      this.fileValidationMsg = FILENAME_VALIDATION_MESSAGE;
      this.showFileValidation = true;
    } else {
      this.incidentservice.postFile(this.fileToUpload, this.incidentUploadSqlForm.get('uploadclusters').value, this.incidentUploadSqlForm.get('uploadsite').value, this.incidentUploadSqlForm.get('bigcategories').value, this.incidentUploadSqlForm.get('currency').value).pipe(takeUntil(this.rxUnsubscribe))
        .subscribe((event: HttpEvent<any>) => {
          if (event.type === 0) {
            this.progressValue = 25;
            this.showProgress = true;
          }
          if (event.type === 1) {
            this.progressValue = 50;
            this.showProgress = true;
          }
          if (event.type === 2) {
            this.progressValue = 75;
            this.showProgress = true;
          }
          if (event.type === 3) {
            this.progressValue = 100;
            setTimeout(() => {
              this.getIncidentFileDetails();
              this.loading = false;
              this.showProgress = false;
            }, 1000);
          }
          if (event.type === 4) {
            if (event instanceof HttpResponse) {
              this.fileValidationMsg = event.body.errorMessage;
              if (this.fileValidationMsg !== '' && this.fileValidationMsg !== null && this.fileValidationMsg !== undefined) {
                this.showFileValidation = true;
              }
              this.recordInserted = event.body.totalRowsInserted;
              this.recordRejected = event.body.totalRowsSkippedWithError;
              this.recordDuplicated = event.body.duplicateRows;
              this.recordUpdated = event.body.updatedRows;
              if (this.recordInserted != null) {
                this.uploadinserted = 'Number of records uploaded : ' + this.recordInserted;
                this.showSuccess = true;
              }
              if (this.recordRejected != null) {
                this.uploadrejected = 'Number of records rejected : ' + this.recordRejected;
                this.showSuccess = true;
              }
              if (this.recordDuplicated != null) {
                this.uploadduplicated = 'Number of records Duplicated : ' + this.recordDuplicated;
                this.showSuccess = true;
              }
              if (this.recordUpdated != null) {
                this.uploadupdated = 'Number of records Updated : ' + this.recordUpdated;
                this.showSuccess = true;
              }
              this.dashboardsqlservice.setCluster(this.incidentUploadSqlForm.get('uploadclusters').value);
              this.dashboardsqlservice.setSite(this.incidentUploadSqlForm.get('uploadsite').value);
              this.dashboardsqlservice.setBigCategory(this.incidentUploadSqlForm.get('bigcategories').value);
              setTimeout(() => {
                this.showSuccess = false;
              }, 30000);
            }
          }
        }, (error) => {
          this.showProgress = false;
          this.showSuccess = false;
          // this.validateSG = error.error.message;
          // this.formattedString = this.validateSG.split('\n');
          // this.openDialogError();
          this.fileValidationMsg = 'Failed to upload the file. Inappropriate data in the excel file may cause this issue.' + error.error.message;
          this.showFileValidation = true;
        });
    }
    this.myInputVariable.nativeElement.value = '';
    setTimeout(() => {
      this.showFileValidation = false;
    }, 30000);
  }
  // method to navigate QAMatrix tab onclick of fileName link
  /* istanbul ignore next */
  loadErrorDetails(fileId: string) {
    this.showSuccess = false;
    this.getErrorDetails(fileId);
  }

  loadDeleteDataPage(fileId: string) {
    this.router.navigate(['/deleteincidentdata'], { queryParams: { id: fileId } });
  }
  // method to navigate Dashboard tab onClick of view dashborad link
  /* istanbul ignore next */
  loadDashboard() {
    this.router.navigate(['/dashboardsql']);
  }
  // method for showing error dialog box
  openDialogError(): void {
    this.dialog.open(IncidentUploadSQLErrorPopupComponent, {
      data: { name: this.formattedString }
    });
  }
  // method for showing error dialog box
  openUploadErrorDetails(): void {
    this.dialog.open(IncidentUploadSQLErrorDetailsComponent, {
      data: { name: this.errorDetailsResponse }
    });
  }
  // Authorization
  get isAuthorized() {
    this.role = localStorage.getItem('role');
    if (this.role === Role.qualityManager || this.role === Role.qualityEngineer || this.role === Role.globalAdmin || this.role === Role.ITSupport) {
      return true;
    } else {
      return false;
    }
  }
}

@Component({
  selector: 'app-incident-upload-error-popup',
  templateUrl: 'incident-Upload-Error-Popup.html',
})

// Component loads the incident upload error-popup
/* istanbul ignore next */
export class IncidentUploadSQLErrorPopupComponent {

  constructor(
    public dialogRef: MatDialogRef<IncidentUploadSQLErrorPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) { }

  onNoClick(): void {
    this.dialogRef.close();
  }
}

// Component loads the upload error details

@Component({
  selector: 'app-incident-upload-sql-errordetails',
  templateUrl: 'incident-upload-sql-errordetails.html',
  styleUrls: ['./incident-upload.component.scss']
})
export class IncidentUploadSQLErrorDetailsComponent implements OnInit {
  displayedColumns: any;
  dataSource: any;
  noRecords = NO_RECORDS;
  noRecordsShow = false;
  constructor(
    public dialogRef: MatDialogRef<IncidentUploadSQLErrorDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ErrorDetails) { }

  ngOnInit() {
    this.displayedColumns = ERRORDETAILSSQL;
    this.dataSource = this.data.name;
    if (this.data.name.length === 0) {
      this.noRecordsShow = true;
    } else {
      this.noRecordsShow = false;
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
